import * as React from "react"
import * as CheckboxPrimitive from "@radix-ui/react-checkbox"
import { CheckIcon, MinusIcon } from "lucide-react"

import { cn } from "../lib/utils"

type CheckboxProps = React.ComponentProps<typeof CheckboxPrimitive.Root> & {
  indeterminate?: boolean
  label?: React.ReactNode
  id?: string
}

function Checkbox({
  className,
  disabled,
  indeterminate,
  label,
  id,
  ...props
}: CheckboxProps) {
  return (
    <label
      htmlFor={id}
      className={cn(
        "inline-flex items-center gap-2 cursor-pointer",
        disabled && "cursor-not-allowed opacity-70",
      )}
    >
      <CheckboxPrimitive.Root
        data-slot="checkbox"
        id={id}
        disabled={disabled}
        checked={indeterminate ? "indeterminate" : props.checked}
        className={cn(
          "peer size-5 shrink-0 rounded-sm border border-secondary hover:border-primary shadow-xs outline-none transition-shadow",
          "cursor-pointer focus-visible:ring-secondary",
          "focus-visible:border-secondary focus-visible:ring-[3px]",
          "aria-invalid:ring-error-500/20 aria-invalid:border-error-500",
          "disabled:cursor-not-allowed disabled:bg-disabled2 disabled:border-none",
          !disabled && [
            "data-[state=checked]:bg-primary data-[state=checked]:text-bg-500 data-[state=checked]:border-primary",
            "data-[state=indeterminate]:bg-primary data-[state=indeterminate]:text-bg-500 data-[state=indeterminate]:border-primary",
          ],
          className
        )}
        {...props}
      >
        <CheckboxPrimitive.Indicator
          data-slot="checkbox-indicator"
          className="flex items-center justify-center transition-none  text-white"
        >
          {indeterminate ? (
            <MinusIcon className="size-3.5 text-white" />
          ) : (
            <CheckIcon className="size-3.5 text-white" />
          )}
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
      {label && (
        <span className="text-sm text-text-500 leading-none select-none">
          {label}
        </span>
      )}
    </label>
  )
}

export { Checkbox }
